import React from 'react'

const Footer = () => {
  const currYear = new Date().getFullYear()

  return (
    <footer>
      &copy; {currYear} &mdash; Quick Sprout, LLC
    </footer>
  )
}

export default Footer


// WEBPACK FOOTER //
// ./src/components/homepage/footer.js